module.exports = __webpack_public_path__ + "static/img/200077.51723051.png";